export const mapperResponseToProductList = (
  list,
  categoryId,
  baseImagePath,
  basePath
) => {
  let listMapped = [];

  list.forEach((productGroups) => {
    productGroups.elements.forEach((elements) => {
      elements.commercialComponents.forEach((commercialComponents) => {
        if (commercialComponents.type === "Product") {
          const newObject = {};
          newObject.image = generateUrlImage(
            baseImagePath,
            commercialComponents.xmedia[0].path,
            commercialComponents.xmedia[0].name,
            commercialComponents.xmedia[0].timestamp
          );
          newObject.name = commercialComponents.name;
          newObject.navigate = generateUrlNavigate(
            basePath,
            commercialComponents.seo.keyword,
            commercialComponents.seo.seoProductId,
            commercialComponents.seo.discernProductId,
            categoryId
          );

          listMapped.push(newObject);
        }
      });
    });
  });
  return listMapped;
};

const generateUrlImage = (baseImagePath, path, name, timestamp) => {
  return `${baseImagePath}/${path}/w/1024/${name}.jpg?ts=${timestamp}`;
};

const generateUrlNavigate = (
  basePath,
  path,
  productId,
  discernProductId,
  categoryId
) => {
  return `${basePath}/${path}-p${productId}.html?v1=${discernProductId}&v2=${categoryId}`;
};
